module.exports = __webpack_public_path__ + "static/media/microvista_logo.27f32c0b.svg";